export default function InputChecklist(props) {
    return(
        <div className="input-group">
            <span className="input-group-text text-primary">
                {props.label}
            </span>
            <input className="form-control" type={props.type} disabled={true} required={props.required} value={props.value}/>
        </div>
    )
}